document.addEventListener("DOMContentLoaded", function () {
    const searchParams = new URLSearchParams(window.location.search);
    const orderId = searchParams.get('orderId');
    const email = searchParams.get('email');
    const pwd = searchParams.get('pwd');
    let InvoiceTitle = '';
    if(email || pwd){
        getPrintableElement();
    }else{
        return ;
    }
    // 
    async function  getPrintableElement() {
        const currentDomain = window.location.hostname;
        const {site,apiUrl,symbol,tin} = getSite();
        try {
            const response = await fetch(`${apiUrl}/api/shopify/order-by-id?orderId=${encodeURIComponent(orderId)}&storeName=${site}`, {
              method: "GET",
              headers: {
                'X-Origin-Domain': currentDomain
              },
            });
            const result = await response.json();
            
            if (result.code === 200) {
              if (!result.data) {
                console.log("No data")
              } else {
                renderInfoHtml(result.data,symbol,tin,site);
              }
            } else {
            }
          } catch (error) {
            throw error;
          }
    }

    function getSite(){
        const currentDomain = window.location.hostname;
        switch (currentDomain) {
          case "uk.renogy.com":
            return {site:"UK",apiUrl:`https://shopify-api.renogy.com`,symbol: '£',tin: '492723861'};
          case "www.renogy.com":
            return {site:"US",apiUrl:`https://shopify-api.renogy.com`,symbol: '$',tin: '47-1717391'};
          case "ca.renogy.com":
            return {site:"CA",apiUrl:`https://shopify-api.renogy.com`,symbol: 'CAD$',tin: ['769976960RT001', 'PST-1499-7244', '8232316','NR00123196','165928-3']};
          case "au.renogy.com":
            return {site:"AU",apiUrl:`https://shopify-api.renogy.com`,symbol: 'AU$',tin: '33662786129'};
          case "de.renogy.com":
            return {site:"DE",apiUrl:`https://shopify-api.renogy.com`,symbol: '€',tin: 'DE360579551'};
          case "eu.renogy.com":
            return {site:"EU",apiUrl:`https://shopify-api.renogy.com`,symbol: '€',tin: 'DE360579551'};
          case "jp.renogy.com":
            return {site:"JP",apiUrl:`https://shopify-api.renogy.com`,symbol: '￥',tin: 'T1012401031951'};
          case "fr.renogy.com":
            return {site:"FR",apiUrl:`https://shopify-api.renogy.com`,symbol: '€',tin: 'DE360579551'};
          case "nl.renogy.com":
            return {site:"NL",apiUrl:`https://shopify-api.renogy.com`,symbol: '€',tin: 'DE360579551'};
          case "it.renogy.com":
            return {site:"IT",apiUrl:`https://shopify-api.renogy.com`,symbol: '€',tin: 'DE360579551'};
          case "es.renogy.com":
            return {site:"ES",apiUrl:`https://shopify-api.renogy.com`,symbol: '€',tin: 'DE360579551'};
          default:
            return {site:"RenogyTest",apiUrl:`https://d-shopify-api.renogy.cn`,symbol: '$',tin: '492723861'};
        }
    }
    function renderInfoHtml(infoData,symbol,tin,site){
        const {orderDetail, storeInfo} = infoData;
        const storeName = storeInfo?.name || 'UK';
        const orderNumber = orderDetail?.name || '';
        let Invoice = document.querySelector(".Invoice");
        Invoice.style.visibility = 'visible';
        const printInvoice = document.querySelector("[data-print-invoice]")?.innerHTML || '';
   
        if(!infoData){
            Invoice.innerHTML = ``;
            return;  
        }
       
        Invoice.innerHTML = `
            <h1>
                <div class="header-logo-image-container">
                <img
                    class="header-logo-image"
                    data-sizes="auto"
                    src="https://uk.renogy.com/cdn/shop/files/RNG-250207-ENERGY-01.png?v=1746511831&width=150"
                    alt="${storeName}"
                    title="${storeName}"
                >
                    <address class="company-address">
                        
                    </address>
                </div>
            </h1>
            <div class="InvoiceTitle"></div>
            <div class="AddressRow">
                <div class="BillingAddress">
                
                </div>
                <div class="ShippingAddress">
                
                </div>
            </div>

            <div class="InvoiceDetails">
                
            </div>

            <div class="InvoiceItems">
                <h2 class="InvoiceHeading">Order Items</h2>
                <table class="InvoiceTable">
                
                </table>
                
            </div>`;
        const companyName = document.querySelector("[data-print-company-name]")?.innerHTML || '';
        InvoiceTitle = document.querySelector('.InvoiceTitle')
        // 格式化 Invoice Number: 在国家代码后面加 1100（排除 US）
        // 例如: TEST5432 -> TEST11005432, 但 US 保持原样
        let invoiceNumber;
        if (site === 'US') {
            invoiceNumber = orderNumber; // US 不加 1100
        } else {
            invoiceNumber = orderNumber.replace(/^([A-Z]+)(\d+)$/, '$11100$2');
        }
        
        // 格式化 TIN 显示
        let tinHtml = '';
        if (tin) {
            if (Array.isArray(tin)) {
                // 如果是数组（如 CA 有多个税号）
                tinHtml = '<br>TIN: ' + tin.join(', ');
            } else if (tin !== '') {
                // 如果是单个税号
                tinHtml = '<br>TIN: ' + tin;
            }
        }
        
        InvoiceTitle.innerHTML = `${companyName ? companyName : storeName}<br> Invoice for Order ${orderNumber}${printInvoice ? `<br>${printInvoice}` : ''}<br>Invoice Number: ${invoiceNumber}${tinHtml}`;
        renderCompanyHtml(storeInfo.billingAddress)
        renderBilingHtml(orderDetail)
        renderShipInfoHtml(orderDetail)
        renderInvoiceDetails(orderDetail)
        renderOrderItem(orderDetail,symbol)
        waitForImagesToLoad().then(() => {
            window.print();
        }).catch(error => {
            window.print(); // 即使失败也尝试打印
        });
    }
    /** 
        * 等待所有图片加载完成
    */
    function waitForImagesToLoad() {
        return new Promise((resolve, reject) => {
            const images = document.querySelectorAll('img');
            let loadedCount = 0;

            // 如果没有图片，直接resolve
            if (images.length === 0) {
                resolve();
                return;
            }

            // 检查每张图片的加载状态
            images.forEach(img => {
                if (img.complete) {
                    // 图片已经加载完成
                    loadedCount++;
                    checkAllLoaded();
                } else {
                    // 监听加载事件
                    img.addEventListener('load', () => {
                        loadedCount++;
                        checkAllLoaded();
                    });
                    img.addEventListener('error', () => {
                        loadedCount++;
                        checkAllLoaded();
                    });
                }
            });

            function checkAllLoaded() {
                if (loadedCount === images.length) {
                    resolve();
                }
            }
        });
    }
    function renderCompanyHtml(addresses){
        const companyAddress = document.querySelector('.company-address');
        companyAddress.innerHTML = `
            <div class="company-address-text">
                ${addresses?.address1 || ''}  ${addresses?.address2 || ''}
            </div>
            <div class="company-address-text">
                ${addresses?.city ? `${addresses?.city},` : ''}   ${addresses?.province || ''}  ${addresses?.zip || ''} 
            </div>
            <div class="company-address-text">
                ${addresses?.country || ''}
            </div>
        `
    }
    function renderBilingHtml(orderDetail){
        const billingAddress = orderDetail.billingAddress;
        const bilingInfo = document.querySelector('.BillingAddress');
        bilingInfo.innerHTML = `
            <h3>Bill To</h3>
            <ul>
                <li><strong>${billingAddress?.name || ''}</strong></li>
                <li>${billingAddress?.company || ''}</li>
                <li>${billingAddress?.address1 || ''}</li>
                <li>${billingAddress?.address2 || ''}</li>
                <li></li>
                <li>${billingAddress?.city ? `${billingAddress?.city},` : ''}  ${billingAddress?.province || ''}  ${billingAddress?.zip || ''}</li>
                <li>${billingAddress?.country || ''}</li>
                <li>&nbsp;</li>
                ${billingAddress?.phone ? `<li>Phone: ${billingAddress.phone}</li>` :''}
            </ul>
        `
    }
    function renderShipInfoHtml(orderDetail){
        const shippingAddress = orderDetail.shippingAddress;
        const shippingInfo = document.querySelector('.ShippingAddress');
        shippingInfo.innerHTML = `
            <h3>Ship To</h3>
            <ul>
                <li><strong>${shippingAddress?.name || ''}</strong></li>
                <li>${shippingAddress?.company || ''}</li>
                <li>${shippingAddress?.address1 || ''}</li>
                <li>${shippingAddress?.address2 || ''}</li>
                <li></li>
                <li>${shippingAddress?.city ? `${shippingAddress?.city},` : ''}  ${shippingAddress?.province || ''}  ${shippingAddress?.zip || ''}</li>
                <li>${shippingAddress?.country || ''}</li>
                <li>&nbsp;</li>
                ${shippingAddress?.phone ? `<li>Phone: ${shippingAddress?.phone}</li>` :''}
            </ul>
        `
    }
    function renderInvoiceDetails(orderDetail){
        const invoiceDetails = document.querySelector('.InvoiceDetails');
        invoiceDetails.innerHTML = `
            <div class="InvoiceDetailsLeft">
                <div class="DetailRow">
                    <div class="Label">Order:</div>
                    <div class="Value">${orderId}</div>
                </div>
                
                </div>
                <div class="InvoiceDetailsRight">
                <div class="DetailRow">
                    <div class="Label">Order Date:</div>
                    <div class="Value">${orderDetail?.processedAt ? timeHandler(orderDetail.processedAt) : ''}</div>
                </div>
            </div>`;
    }
    function timeHandler(time, region = 'DE') {
        const date = new Date(time);
        // 格式化为英国时间
        const options = {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false, // 24小时制
          timeZone: "Europe/London", // 设置为伦敦时区
        };
        return date.toLocaleString(options.locale || "en-GB", options);
        }

    function renderOrderItem(orderDetail,symbol){
        const orderItemData = processOrderData(orderDetail);
        const invoiceDetialsTable = document.querySelector('.InvoiceTable');
        let InvoiceTotalsHtml = ``;
        orderItemData.forEach((item)=>{
            InvoiceTotalsHtml += `
                <tr class="NewAddress">
                    <td class="ProductQuantity">${item.node.quantity || ''}</td>
                    <td class="ProductSku">${item.node?.variant?.sku || ''} ${item.node?.isRefunded ? '(refund)' :''} </td>
                    <td class="ProductDetails">
                        ${item.node?.name || ''}
                    </td>
                    <td class="ProductCost">${item.node?.isRefunded ? `-` :``} ${item.node?.originalUnitPriceSet?.shopMoney?.amount || ''}</td>
                    <td class="ProductTotal">${item.node?.isRefunded ? '-' :''} ${symbol}${singleItemTotal(item.node?.originalUnitPriceSet?.shopMoney?.amount,item.node?.quantity)}</td>
                </tr>
            `
        })
        const tableHtml = `
             <thead>
                <tr>
                <th class="ProductQuantity">Qty</th>
                <th class="ProductSku">Code/SKU</th>
                <th class="ProductDetails">Product Name</th>
                <th class="ProductCost" align="right">Price</th>
                <th class="ProductTotal" align="right">Total</th>
                </tr>
            </thead>
            <tbody class="InvoiceItemList">
               ${InvoiceTotalsHtml}
            </tbody>
            <tfoot class="InvoiceTotals">
                <tr class="InvoiceTotalRow">
                    <td class="Title" colspan="4">Subtotal</td>
                    <td class="Total">${symbol}${orderDetail.subtotalPriceSet?.shopMoney.amount || ''}</td>
                </tr>
                <tr class="InvoiceTotalRow">
                    <td class="Title" colspan="4">Discount</td>
                    <td class="Total">-${symbol}${orderDetail.totalDiscountsSet?.shopMoney.amount || ''}</td>
                </tr>
                <tr class="InvoiceTotalRow">
                    <td class="Title" colspan="4">Shipping</td>
                    <td class="Total">${symbol}${orderDetail.totalShippingPriceSet?.shopMoney.amount || ''}</td>
                </tr>
                <tr class="InvoiceTotalRow">
                    <td class="Title" colspan="4">Tax</td>
                    <td class="Total">${symbol}${orderDetail.totalTaxSet?.shopMoney.amount || ''}</td>
                </tr>
                <tr class="InvoiceTotalRow">
                    <td class="Title" colspan="4">Total</td>
                    <td class="Total">${symbol}${orderDetail.totalPriceSet?.shopMoney.amount || ''}</td>
                </tr>
                <tr class="InvoiceTotalRow">
                    <td class="Title" colspan="4">Refund</td>
                    <td class="Total">-${symbol}${orderDetail.totalRefundedSet?.shopMoney.amount || ''}</td>
                </tr>
            </tfoot>
        `
        invoiceDetialsTable.innerHTML = tableHtml;
    }

    // 处理订单数据
    function processOrderData(orderData) {
        // 获取所有退款商品的SKU列表
        const refundedSkus = [];
        if (orderData.refunds && orderData.refunds.length > 0) {
        orderData.refunds.forEach(refund => {
            if (refund.refundLineItems && refund.refundLineItems.edges) {
            refund.refundLineItems.edges.forEach(edge => {
                if (edge.node.lineItem && edge.node.lineItem.variant) {
                refundedSkus.push(edge.node.lineItem.variant.sku);
                }
            });
            }
        });
        }
    
        // 处理lineItems，添加isRefunded标记
        if (orderData.lineItems && orderData.lineItems.edges) {
            const processedLineItems = orderData.lineItems.edges.map(edge => {
                const node = {...edge.node}; // 创建副本避免修改原数据
                const sku = node.variant?.sku;
                
                // 检查当前商品是否在退款列表中
                node.isRefunded = refundedSkus.includes(sku);
                
                // 如果需要，可以添加退款相关信息
                if (node.isRefunded) {
                const refundInfo = orderData.refunds.find(refund => 
                    refund.refundLineItems.edges.some(item => 
                    item.node.lineItem.variant.sku === sku
                    )
                );
                node.refundInfo = {
                    refundedAt: refundInfo?.createdAt,
                    refundAmount: refundInfo?.totalRefundedSet?.shopMoney?.amount
                };
                }
                
                return {node};
            });
        
            return processedLineItems;
        }
    }

    // 单品总价计算
    function singleItemTotal(price,quantity){
        if (price <= 0 || quantity <= 0) {
            throw new Error('');
        }
        const total = price * quantity;
        return parseFloat(total.toFixed(2));
    }
  
})